import { gql } from '@apollo/client';

export const CALENDAR_FRAGMENT = gql`
  fragment CalendarFragment on PaidCalendar {
    id
    name
    skuId
    startDate
    endDate
    purchaseReward {
      type
      amount
      itemId
    }
    calendarItems {
      type
      amount
      itemId
    }
    filterUserIds
    filterVersion
  }
`;

export const GET_CALENDARS = gql`
  query getCalendars {
    getCalendars {
      ...CalendarFragment
    }
  }
  ${CALENDAR_FRAGMENT}
`;

export const UPDATE_CALENDAR = gql`
  mutation updateCalendarAdmin(
    $id: ID!
    $name: String!
    $calendarItems: [LevelRewardInput!]!
    $skuId: String!
    $startDate: Date!
    $endDate: Date!
    $purchaseReward: LevelRewardInput
    $filterUserIds: [ID!]!
    $filterVersion: Int
  ) {
    updateCalendarAdmin(
      id: $id
      name: $name
      calendarItems: $calendarItems
      skuId: $skuId
      startDate: $startDate
      endDate: $endDate
      purchaseReward: $purchaseReward
      filterUserIds: $filterUserIds
      filterVersion: $filterVersion
    ) {
      ...CalendarFragment
    }
  }
  ${CALENDAR_FRAGMENT}
`;

export const CREATE_CALENDAR = gql`
  mutation createCalendarAdmin($name: String!, $startDate: Date!, $endDate: Date!) {
    createCalendarAdmin(name: $name, startDate: $startDate, endDate: $endDate) {
      ...CalendarFragment
    }
  }
  ${CALENDAR_FRAGMENT}
`;

export const REMOVE_CALENDAR = gql`
  mutation removeCalendarAdmin($id: ID!) {
    removeCalendarAdmin(id: $id) {
      isRemoved
    }
  }
`;
